import { bindable } from "aurelia-framework";
import moment from "moment";

export class WlTrialTimeline {
  @bindable subscription;
  @bindable unlimitedFee;
  @bindable starterFee;
  @bindable starterUserFee;
  @bindable currencySign;

  constructor() {
    this.nextDate1 = moment().add(7, "days");
    this.nextDate2 = moment().add(12, "days");
    this.nextDate3 = moment().add(14, "days");
    this.currentDate = moment().format("YYYY-MM-DD");
    console.log(this.currentDate);
  }

  attached() {
    console.log(
      this.subscription,
      this.starterFee,
      this.unlimitedFee,
      this.currencySign
    );
  }

  activate() {}

  calculateChargeableAmount(subscriptionCost, startDate) {
    const monthlyRate = subscriptionCost;
    const freeTrialDays = 14;

    // Create a date object from the start date
    const start = new Date(startDate);

    // Calculate the trial end date
    const trialEndDate = new Date(start.getTime());
    trialEndDate.setDate(trialEndDate.getDate() + freeTrialDays);

    // Get the number of days in the trial end month
    const trialEndYear = trialEndDate.getFullYear();
    const trialEndMonth = trialEndDate.getMonth();
    const daysInTrialEndMonth = new Date(
      trialEndYear,
      trialEndMonth + 1,
      0
    ).getDate();

    // Calculate the daily rate for the trial end month
    const dailyRate = monthlyRate / daysInTrialEndMonth;

    // Calculate chargeable days in the trial end month
    let chargeableDays = 0;
    if (trialEndDate.getDate() <= daysInTrialEndMonth) {
      chargeableDays = daysInTrialEndMonth - trialEndDate.getDate();
    }

    // Calculate the chargeable amount
    const chargeableAmount = chargeableDays * dailyRate;

    return chargeableAmount.toFixed(2);
    return {
      dailyRate: dailyRate.toFixed(2),
      chargeableDays: chargeableDays,
      chargeableAmount: chargeableAmount.toFixed(2),
    };
  }

  // Example usage:
  // const subscriptionCost = 200;
  // const startDate = '2024-07-25'; // Assuming the user starts the subscription on July 25, 2024
  // const result = calculateChargeableAmountForNextMonth(subscriptionCost, startDate);
  // console.log(result);
}
